import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';
import './auth.css';

const MIN_LENGTH = 8;

const ResetPasswordPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const { resetPassword } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setError('Пароли не совпадают');
            return;
        }
        setError('');
        setLoading(true);

        try {
            await resetPassword(token, password);
            setSuccess(true);
            setTimeout(() => navigate('/login'), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Не удалось сменить пароль. Попробуйте позже.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-screen">
            <div className="auth-wrap">
                <p className="auth-brand">PASSX</p>

                <div className="auth-panel">
                    <header className="auth-head">
                        <h1 className="auth-title">Новый пароль</h1>
                        <p className="auth-lead">Не короче {MIN_LENGTH} символов</p>
                    </header>

                    {!token && (
                        <div className="auth-alert auth-alert--warn" role="alert">
                            <AlertCircle size={20} aria-hidden="true" />
                            <span>
                                В ссылке нет кода сброса. Откройте ссылку из письма целиком или{' '}
                                <Link className="auth-link" to="/forgot-password">запросите новую</Link>.
                            </span>
                        </div>
                    )}

                    {error && (
                        <div className="auth-alert auth-alert--warn" role="alert" id="reset-error">
                            <AlertCircle size={20} aria-hidden="true" />
                            <span>{error}</span>
                        </div>
                    )}

                    {success ? (
                        <div className="auth-alert auth-alert--ok" role="status">
                            <CheckCircle2 size={20} aria-hidden="true" />
                            <span>Пароль изменён. Сейчас откроем страницу входа.</span>
                        </div>
                    ) : token && (
                        <form className="auth-form-body" onSubmit={handleSubmit}>
                            <div className="auth-field">
                                <label className="auth-label" htmlFor="reset-password">Новый пароль</label>
                                <input
                                    id="reset-password"
                                    className="auth-input"
                                    type="password"
                                    autoComplete="new-password"
                                    minLength={MIN_LENGTH}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    aria-invalid={error ? 'true' : undefined}
                                    aria-describedby={error ? 'reset-error' : undefined}
                                />
                            </div>
                            <div className="auth-field">
                                <label className="auth-label" htmlFor="reset-confirm">Повторите пароль</label>
                                <input
                                    id="reset-confirm"
                                    className="auth-input"
                                    type="password"
                                    autoComplete="new-password"
                                    minLength={MIN_LENGTH}
                                    value={confirm}
                                    onChange={(e) => setConfirm(e.target.value)}
                                    required
                                    aria-invalid={error ? 'true' : undefined}
                                    aria-describedby={error ? 'reset-error' : undefined}
                                />
                            </div>
                            <button
                                className="auth-submit"
                                type="submit"
                                disabled={loading}
                                aria-busy={loading ? 'true' : undefined}
                            >
                                {loading && <Loader2 size={20} className="auth-spin" aria-hidden="true" />}
                                {loading ? 'Сохранение...' : 'Сохранить пароль'}
                            </button>
                        </form>
                    )}

                    <p className="auth-switch">
                        <Link className="auth-link" to="/login">Вернуться ко входу</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
